import { ChainId } from '@swapsicledex/swapsicle-sdk'

export const FARM_POOLS_V1 = {
  [ChainId.TELOS]: [
    {
      pid: 1,
      chef: 0,
      pair: {
        id: '0x6DEE26F527ADB0C24FeF704228D8E458b46f9f5F',
        token0: {
          address: '0x173fd7434B8B50dF08e3298f173487ebDB35FD14',
          symbol: 'POPS',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 2,
      chef: 0,
      pair: {
        id: '0x76EB0fa76C00F3FA23697d1297fC5BD79577ea5C',
        token0: {
          address: '0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b',
          symbol: 'USDC',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 3,
      chef: 0,
      pair: {
        id: '0x931203d780588cd0aB58558E8838776ACC88f5ee',
        token0: {
          address: '0xB4B01216a5Bc8F1C8A33CD990A1239030E60C905',
          symbol: 'sTLOS',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 4,
      chef: 0,
      pair: {
        id: '0xEa4F6c46c09b0cF20716A0047DA3A1dAE5b01965',
        token0: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
        token1: {
          address: '0xfA9343C3897324496A05fC75abeD6bAC29f8A40f',
          symbol: 'WETH',
        },
      },
    },
    {
      pid: 5,
      chef: 0,
      pair: {
        id: '0xedB94024352F3b921e5801626142411D0Fb03bE2',
        token0: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
        token1: {
          address: '0xf390830DF829cf22c53c8840554B98eafC5dCBc2',
          symbol: 'WBTC',
        },
      },
    },
    {
      pid: 6,
      chef: 0,
      pair: {
        id: '0xEDBF19cC88FfC8EfabbDc35bCFABF8d8DA309A56',
        token0: {
          address: '0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b',
          symbol: 'USDC',
        },
        token1: {
          address: '0xB4B01216a5Bc8F1C8A33CD990A1239030E60C905',
          symbol: 'sTLOS',
        },
      },
    },
    {
      pid: 7,
      chef: 0,
      pair: {
        id: '0x4eCFB6264f4D5c719A0cC1d4e4998819c3EF0Ab1',
        token0: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
        token1: {
          address: '0xeFAeeE334F0Fd1712f9a8cc375f427D9Cdd40d73',
          symbol: 'USDT',
        },
      },
    },
    {
      pid: 8,
      chef: 2,
      pair: {
        id: '0xcC3929051f3FD92905e19B34503e51035957D5c7',
        token0: {
          address: '0x332730a4F6E03D9C55829435f10360E13cfA41Ff',
          symbol: 'MATIC',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 9,
      chef: 2,
      pair: {
        id: '0xac5855f36D09833036D2567f28748E553dee5942',
        token0: {
          address: '0x7C598c96D02398d89FbCb9d41Eab3DF0C16F227D',
          symbol: 'AVAX',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 1,
      chef: 2,
      pair: {
        id: '0x6DEE26F527ADB0C24FeF704228D8E458b46f9f5F',
        token0: {
          address: '0x173fd7434B8B50dF08e3298f173487ebDB35FD14',
          symbol: 'POPS',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 2,
      chef: 2,
      pair: {
        id: '0x76EB0fa76C00F3FA23697d1297fC5BD79577ea5C',
        token0: {
          address: '0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b',
          symbol: 'USDC',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 3,
      chef: 2,
      pair: {
        id: '0x931203d780588cd0aB58558E8838776ACC88f5ee',
        token0: {
          address: '0xB4B01216a5Bc8F1C8A33CD990A1239030E60C905',
          symbol: 'sTLOS',
        },
        token1: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
      },
    },
    {
      pid: 4,
      chef: 2,
      pair: {
        id: '0xEa4F6c46c09b0cF20716A0047DA3A1dAE5b01965',
        token0: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
        token1: {
          address: '0xfA9343C3897324496A05fC75abeD6bAC29f8A40f',
          symbol: 'WETH',
        },
      },
    },
    {
      pid: 5,
      chef: 2,
      pair: {
        id: '0xedB94024352F3b921e5801626142411D0Fb03bE2',
        token0: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
        token1: {
          address: '0xf390830DF829cf22c53c8840554B98eafC5dCBc2',
          symbol: 'WBTC',
        },
      },
    },
    {
      pid: 6,
      chef: 2,
      pair: {
        id: '0xEDBF19cC88FfC8EfabbDc35bCFABF8d8DA309A56',
        token0: {
          address: '0x818ec0A7Fe18Ff94269904fCED6AE3DaE6d6dC0b',
          symbol: 'USDC',
        },
        token1: {
          address: '0xB4B01216a5Bc8F1C8A33CD990A1239030E60C905',
          symbol: 'sTLOS',
        },
      },
    },
    {
      pid: 7,
      chef: 2,
      pair: {
        id: '0x4eCFB6264f4D5c719A0cC1d4e4998819c3EF0Ab1',
        token0: {
          address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
          symbol: 'WTLOS',
        },
        token1: {
          address: '0xeFAeeE334F0Fd1712f9a8cc375f427D9Cdd40d73',
          symbol: 'USDT',
        },
      },
    },
  ],
  [ChainId.TELOS_TESTNET]: [
    {
      pid: 1,
      chef: 0,
      pair: {
        id: '0xB6A95d05FB5c45E71804791FA7132519db0c20AC',
        token0: {
          address: '0x6E2542aFC68a1697FeB2810437DF9409D3b93493',
          symbol: 'WTLOS',
        },
        token1: {
          address: '0x950570d7B3CeC2d93b506d2D4eB53f38cbD130b0',
          symbol: 'POPS',
        },
      },
    },
    {
      pid: 2,
      chef: 0,
      pair: {
        id: '0x876E4977f5ED925eA8c21432F8C58521a4C7b1A3',
        token0: {
          address: '0x950570d7B3CeC2d93b506d2D4eB53f38cbD130b0',
          symbol: 'POPS',
        },
        token1: {
          address: '0xB38239b39f141CB9CdBf25e86f5eD37a6915d2DD',
          symbol: 'USDT',
        },
      },
    },
  ],
  [ChainId.AVALANCHE]: [
    {
      pid: 1,
      chef: 0,
      pair: {
        id: '0x7E454625e4bD0CFdC27e752B46bF35C6343D9A78',
        token0: {
          address: '0x240248628B7B6850352764C5dFa50D1592A033A8',
          symbol: 'POPS',
        },
        token1: {
          address: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
          symbol: 'WAVAX',
        },
      },
    },
    {
      pid: 2,
      chef: 0,
      pair: {
        id: '0xDf758176f320BBB9539ACc3DeE51ffaa3Ba9B4Db',
        token0: {
          address: '0x240248628B7B6850352764C5dFa50D1592A033A8',
          symbol: 'POPS',
        },
        token1: {
          address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
          symbol: 'USDC',
        },
      },
    },
  ],
}
